/**
 * Extract text from JSX
 */
export const extractTextFromJSX = element => {
  if (element === null || element === undefined) return '';

  // If it is a string or number, return it
  if (typeof element === 'string') return element;
  if (typeof element === 'number') return String(element);
  if (typeof element === 'boolean') return '';

  // If it is an array, process each element
  if (Array.isArray(element)) return element.map(extractTextFromJSX).join('');

  // If it is a React element with props
  if (element?.props) {
    // Try to get the text from the defaultMessage (FormattedMessage)
    if (element.props.defaultMessage) return element.props.defaultMessage;
    if (element.props.id && typeof element.props.id === 'string') return element.props.id;

    // Extract text from children recursively
    if (element.props.children) {
      return extractTextFromJSX(element.props.children);
    }
  }

  return '';
};
